import {Link, useParams} from "react-router-dom";
import {useSelector} from "react-redux";
import ComicList from "../ComicList";
import {useTitle} from "../useTitle";

function Archive({ story }) {

  let { char } = useParams();

  const stories = useSelector(state => state.stories);
  const comics = stories.comics[story];
  const comicsList = new ComicList(comics);

  useTitle('Archive' + (char ? ` - ${char.replace(/^(\w)/, l => l.toUpperCase())}` : ''));

  return (
    <div className={`archive ${char || ''}`}>
      <h2>Archive</h2>
      <ul>
        {
          comicsList.allComics(char).map(comic => (
            <li className={comic.chars.map(char => char.toLowerCase()).join(' ')} key={comic.number}>
              <Link to={`./../${comic.number}`}>
                {comic.number}: {comic.chars.join(', ')}: {comic.title}
              </Link>
            </li>
          ))
        }
      </ul>
    </div>
  );
}

export default Archive;